import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import api from "../../../services/api";
import toastOptions from "../../../utils/toastOptions";
import CongregationChart from "../../congregation/congregation-chart/CongregationChart";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faPlus } from "@fortawesome/free-solid-svg-icons";
import { currencyMask } from "../../../utils/masks";
import CampaignChartDates from "../campaign-chart-dates/CampaignChartDates";
import moment from "../../../utils/momentConfig";
import CampaignChartAmount from "../campaign-chart-amount/CampaignChartAmount";
import CampaignChartPaidByMonth from "../campaign-chart-paid-by-month/CampaignChartPaidByMonth";

export default function DashboardCampaign() {
  const [totalPeople, setTotalPeople] = useState<number>();  
  const [totalAmount, setTotalAmount] = useState<number>();
  const [totalPaid, setTotalPaid] = useState<number>();
  const [year, setYear] = useState<number>();
  const [month, setMonth] = useState<number>();
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    try {
      setLoading(true);

      let params = {
        page: 1,
        limit: 1
      } as any;
  
      const { data } = await api.get(`/campaigns`, { params: params });
      setTotalPeople(data.total);
  
      const { data: dataTotalAmount } = await api.get(`/campaigns/amounts`);
      setTotalAmount(dataTotalAmount);
  
      let paramsPaid = {
        year: year,
        month: month
      } as any;

      const { data: dataTotalPaid } = await api.get(`/campaigns/paid`, { params: paramsPaid });
      setTotalPaid(dataTotalPaid);
  
    } catch (e: any) {
      e.messages?.forEach((m: string) => {
        toast.warning(m, toastOptions);
      });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    setTotalPaid(undefined);
    if (year && month) {
      init();
    }
  }, [year, month]);

  const handlePaid = async (value: string) => {
    const val = value.split(";");
    setMonth(+val[0]);
    setYear(+val[1]);
  }

  const getMonthsFromSep2025ToNow = () => {
    const start = moment("2025-09-01");
    const end = moment();
    const months = [];

    let current = start.clone();
    while (current.isSameOrBefore(end, "month")) {
      months.push({
        month: current.month() + 1, // moment months are 0-based
        year: current.year(),
        label: `${current.format("MMMM").toUpperCase()}/${current.year()}`
      });
      current.add(1, "month");
    }
    return months.reverse(); // latest first
  }
  
  return (
    <div
      id="page-dashboad-event"
      className="uk-section uk-section-muted uk-padding-small"
    >
      <div className="uk-container">
        <div className="uk-grid-small uk-margin-bottom" uk-grid="true">
          <div className="uk-width-1-2@s">
            <div className="uk-card uk-card-primary uk-card-small uk-card-hover">
              <div className="uk-card-header">
                <div className="uk-grid-small uk-flex-middle" uk-grid="true">
                  <div className="uk-width-expand">
                    <h3 className="uk-card-title uk-margin-remove-bottom">
                      Doadores Ativos
                    </h3>
                  </div>
                </div>
              </div>
              <div className="uk-card-body">
                {loading ? (
                  <div uk-spinner="true; ratio:2">Carregando...</div>
                ) : (
                  <h1 className="uk-heading-xlarge">{totalPeople}</h1>
                )}
              </div>
              <div className="uk-card-footer">
                <Link to="/campanhas/pessoas">
                  Ver Pessoas <span uk-icon="arrow-right"></span>
                </Link>
              </div>
            </div>
          </div>
          <div className="uk-width-1-2@m uk-flex uk-flex-around uk-flex-column" uk-margin="true">
            <div className="uk-card uk-card-body uk-card-success uk-flex uk-flex-middle uk-flex-center uk-flex-column uk-card-hover uk-margin-small-left">
              <div className="uk-inline-clip uk-transition-toggle uk-text-large uk-text-lighter uk-flex uk-flex-middle uk-flex-around" style={{width: '100%'}}>
                <div className="uk-flex uk-flex-column uk-text-center">
                  <label className="uk-text-small">Valor mensal esperado</label>
                  {loading ? (
                    <div uk-spinner="true; ratio:0.5"></div>
                  ) : (
                    <div className="uk-text-bold uk-text-large">
                      {currencyMask(totalAmount)}
                    </div>
                  )}
                </div>
                <div className="uk-flex uk-flex-column uk-text-center">
                  <span className="uk-text-small">Valor recebido em</span>
                  <div uk-form-custom="target: true" className="uk-text-small uk-text-bold">
                    <select aria-label="Custom controls uk-text-small"
                      onChange={(e) => {handlePaid(e.target.value);}}
                    >
                      {getMonthsFromSep2025ToNow().map(({ month, year, label }) => (
                        <option key={`${month};${year}`} value={`${month};${year}`}>
                          {label}
                        </option>
                      ))}
                    </select>
                    <span></span>
                  </div>
                  {loading ? (
                    <div uk-spinner="true; ratio:0.5"></div>
                  ) : (
                    <div className="uk-text-bold uk-text-large">
                      {currencyMask(totalPaid)}
                    </div>
                  )}
                </div>
              </div>
              <progress id="js-progressbar" 
                className="uk-progress"
                value={totalPaid}
                max={totalAmount}
                uk-tooltip={`title: ${(((totalPaid??0)/(totalAmount??1))*100).toFixed(0)}% recebido este mês`}
              ></progress>
            </div>
            <div className="uk-grid uk-margin-small-left" uk-grid="true">
              <div className="uk-card uk-card-body uk-card-warning uk-flex uk-flex-middle uk-flex-center uk-card-hover uk-width-1-2@s"
                uk-tooltip="title: Adicionar novo doador; pos: top"
              >
                <div className="uk-inline-clip uk-transition-toggle">
                  <div className="uk-transition-scale-up uk-transition-opaque">
                    <Link to="/campanhas/pessoas/novo" className="uk-button">
                      <div className="uk-transition-scale-up uk-transition-opaque uk-flex uk-flex-middle">
                        <FontAwesomeIcon
                          icon={faPlus}
                          size={"2x"}
                          className="uk-margin-right"
                        />
                        Pessoa
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
              <div className="uk-card uk-card-body uk-card-alternative uk-flex uk-flex-middle uk-flex-center uk-card-hover uk-width-1-2@s"
                uk-tooltip="title: Listagem de todos os pagamentos; pos: top"
              >
                <div className="uk-inline-clip uk-transition-toggle">
                  <div className="uk-transition-scale-up uk-transition-opaque">
                    <Link to="/campanhas/pagamentos" className="uk-button">
                      <div className="uk-transition-scale-up uk-transition-opaque uk-flex uk-flex-middle">
                        <FontAwesomeIcon
                          icon={faEye}
                          size={"2x"}
                          className="uk-margin-right"
                        />
                        Pagamentos
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="uk-width-1 uk-margin-bottom">
            <CampaignChartPaidByMonth />
          </div>
          <div className="uk-width-1-2@s">
            <CongregationChart type="campaign" />
          </div>
          <div className="uk-width-1-2@s">
            <CampaignChartAmount />
            <CampaignChartDates />
          </div>
        </div>
      </div>
    </div>
  );
}